import { NgModule, APP_INITIALIZER, Injector } from '@angular/core';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule, Http } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {QuillModule} from 'ngx-quill';
import {
  DataTableModule, SharedModule, FileUploadModule, MenuModule, MenubarModule, ContextMenuModule,
  GrowlModule, OverlayPanelModule, ButtonModule, SplitButtonModule, MultiSelectModule, BlockUIModule,
  PasswordModule, InputTextModule, PanelModule, DialogModule, AutoCompleteModule,
  DropdownModule, InputMaskModule, TooltipModule, CalendarModule, ChartModule, PickListModule, TabViewModule, FieldsetModule, CheckboxModule, TriStateCheckboxModule, ConfirmationService, ConfirmDialogModule,
  MegaMenuModule, EditorModule, GMapModule, MessageModule
} from 'primeng/primeng';
import { MsalModule, MsalInterceptor, MsalService, MsalGuard } from '@azure/msal-angular';
import {MyMsalInterceptor} from './common/MyMsalInterceptor';

// import { Adal5Service, Adal5HTTPService } from 'adal-angular5';
import { TableModule } from 'primeng/table';
import { KeyFilterModule } from 'primeng/keyfilter';

import { AppRoutingModule } from './app.routes';

import { CurrencyMaskModule } from "ng2-currency-mask";

import { AuthenticationGuard } from './common/AuthenticationGuard';
import { AmazingTimePickerModule } from 'amazing-time-picker';

import { AppComponent } from './app.component';

import * as comp from './components/index'
import * as serv from './services/index'

import { UCDirective } from './directives/UCDirective';
import Constants from './constants/Constants';
import Settings from './constants/Settings';
import { RouterModule, Routes } from '@angular/router';

const protectedResourceMapRH = new Map<string, Array<string>>();

protectedResourceMapRH.set(Settings._URL_BASE, [`api://${Settings._API_APPLICATION_ID}/Customer.read`]);



export function configServiceFactory(configService: serv.ConfigService) {
  return () => configService.getConfigs();
}

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export function isInIframe() {
  return window !== window.parent && !window.opener;
}


@NgModule({
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    HttpClientModule,
    FileUploadModule,
    FormsModule,
    ReactiveFormsModule,
    DataTableModule,
    SharedModule,
    MenuModule,
    MenubarModule,
    ContextMenuModule,
    GrowlModule,
    OverlayPanelModule,
    GMapModule,
    MessageModule,
    ButtonModule,
    SplitButtonModule,
    MultiSelectModule,
    BlockUIModule,
    PasswordModule,
    InputTextModule,
    PanelModule,
    DialogModule,
    AutoCompleteModule,
    DropdownModule,
    InputMaskModule,
    TooltipModule,
    CalendarModule,
    ChartModule,
    PickListModule,
    TabViewModule,
    FieldsetModule,
    CheckboxModule,
    TriStateCheckboxModule,
    ConfirmDialogModule,
    CurrencyMaskModule,
    MegaMenuModule,
    EditorModule,
    TableModule,
    KeyFilterModule,
    AmazingTimePickerModule,
    QuillModule.forRoot({
      modules: {
        syntax: true
      }
    }),
    MsalModule.forRoot({
      auth: {
        clientId: Settings._OAUTH_CLIENT_ID,
        authority: Settings._OAUTH_AUTHORITY,
        redirectUri: Settings._OAUTH_REDIRECTURI,
      },
    },
    {protectedResourceMap: protectedResourceMapRH}),
   
  ],
  declarations: [
    AppComponent,
    comp.InfoLabelComponent,
    comp.BlockComponent,
    comp.FormHeaderComponent,
    comp.RequestHeaderComponent,
    comp.MessageHandlerComponent,
    comp.PayerContactSelectorComponent,
    comp.UserMessageComponent,
    comp.UserMessageEditComponent,
    comp.ImportAuditGridComponent,
    comp.LogMessagesGridComponent,
    comp.LogMessageDetailComponent,
    comp.MaintainDSDFreezeComponent,
    comp.MaintainSalesOfficeRequestTypes,
    comp.BillingActionDropdownComponent,
    comp.OutletAcquisitionTypeDropdownComponent,
    comp.ProspectSourceDropdownComponent,
    comp.BillingDiscrepancyRequestReasonDropdownComponent,
    comp.BillingDiscrepancyRequestTypeDropdownComponent,
    comp.BusinessTypeDropdownComponent,
    comp.ClerkDropdownComponent,
    comp.CompletionNumberLabelDropdownComponent,
    comp.ContactDepartmentDropdownComponent,
    comp.ContactFunctionDropdownComponent,
    comp.CoolerDoorDropdownComponent,
    comp.CoolerStyleDropdownComponent,
    comp.CreditHoldActionDropdownComponent,
    comp.CustomerOwnershipDropdownComponent,
    comp.CustomerPaymentTypeDropdownComponent,
    comp.ApprovalTypeDropdownComponent,
    comp.CustomerTypeDropdownComponent,
    comp.DunningBlockDropdownComponent,
    comp.DunningProcedureDropdownComponent,
    comp.EligibilityIndicatorDropdownComponent,
    comp.MerchLevelDropdownComponent,
    comp.MerchPercentageDropdownComponent,
    comp.PalletTypeDropdownComponent,
    comp.PaymentOptionMultiSelectComponent,
    comp.PaymentTermDropdownComponent,
    comp.SelectionRuleDropdownComponent,
    comp.TimeProfileDropdownComponent,
    comp.CallFrequencyDropdownComponent,
    comp.CommissionPaymentFrequencyDropdownComponent,
    comp.SubtradeChannelDropdownComponent,
    comp.DistributionModeDropdownComponent,
    comp.MonthDropdownComponent,
    comp.KeyAccountDropdownComponent,
    comp.TradeGroupDropdownComponent,
    comp.TradeNameDropdownComponent,
    comp.UpdateNeededDropdownComponent,
    comp.PayerTypeDropdownComponent,
    comp.OrderMethodDropdownComponent,
    comp.OrderFrequencyDropdownComponent,
    comp.SpecialEventFrequencyDropdownComponent,
    comp.SpecialEventTypeDropdownComponent,
    comp.VendPackageDropdownComponent,
    comp.SpecificModelReasonDropdownComponent,
    comp.EquipmentCategoryDropdownComponent,
    comp.EquipmentLineItemTypeDropdownComponent,
    comp.EquipmentTypeDropdownComponent,
    comp.ModelGroupDropdownComponent,
    comp.ModelDropdownComponent,
    comp.EquipmentGraphicsDropdownComponent,
    comp.VendSizeDropdownComponent,
    comp.FlavorDropdownComponent,
    comp.FlavorMultiSelectComponent,
    comp.CardReaderDropdownComponent,
    comp.SecurityLevelDropdownComponent,
    comp.LineTypeDropdownComponent,
    comp.LineRunLocationDropdownComponent,
    comp.SuppressionReasonDropdownComponent,
    comp.FamilyTypeDropdownComponent,
    comp.SwapReasonDropdownComponent,
    comp.AccountStatementTypeDropdownComponent,
    comp.ActivityReasonDropdownComponent,
    comp.SalesOfficeDropdownComponent,
    comp.SalesOfficeTypeDropdownComponent,
    comp.StateDropdownComponent,
    comp.FeatureDropdownComponent,
    comp.ShelfDirectionDropdownComponent,
    comp.YesNoDropdownComponent,
    comp.ProductSizeMultiSelectComponent,
    comp.GlideTypeDropdownComponent,
    comp.GlobalCustomerDropdownComponent,
    comp.FullServiceCustomerTypeDropdownComponent,
    comp.FullServicePricingTypeDropdownComponent,
    comp.DelayBetweenOrderAndDeliveryDropdownComponent,
    comp.SectionDropdownComponent,
    comp.CommissionRateDropdownComponent,
    comp.EmployeeDropdownComponent,
    comp.DayOfWeekMultiSelectComponent,
    comp.EquipmentActivityDropdownComponent,
    comp.EquipmentClassDropdownComponent,
    comp.EquipmentClassMultiSelectComponent,
    comp.RequestTypeMultiSelectComponent,
    comp.RequestTypeDropdownComponent,
    comp.ManagedByDropdownComponent,
    comp.MassUpdateEntityDropdownComponent,
    comp.MasterDeliveryRouteDropdownComponent,
    comp.ValidationTypeDropdownComponent,
    comp.RequestStatusMultiSelectComponent,
    comp.EmployeeMultiSelectComponent,
    comp.SalesOfficeMultiSelectComponent,
    comp.EquipmentGraphicsMultiSelectComponent,
    comp.AddressesAutoCompleteComponent,
    comp.EmployeesAutoCompleteComponent,
    comp.CustomersAutoCompleteComponent,
    comp.EquipmentsAutoCompleteComponent,

    comp.EquipmentGridComponent,
    comp.ConvertEquipmentRequestsComponent,
    comp.KeyAccountGridComponent,
    comp.ModelGridComponent,
    comp.ModelGroupGridComponent,
    comp.PrimaryGroupOverrideGridComponent,
    comp.RequestTypeGridComponent,
    comp.VendSizeFlavorXrefGridComponent,
    comp.FullServicePackageConfigGridComponent,
    comp.ActivityReasonEditComponent,
    comp.DomainRecordEditComponent,
    comp.DomainRecordGridComponent,
    comp.SalesOfficeGridComponent,
    comp.ContactValidationGridComponent,
    comp.ActivityReasonGridComponent,
    comp.ValidationGridComponent,

    comp.KeyAccountEditComponent,
    comp.ModelEditComponent,
    comp.ModelGroupEditComponent,
    comp.PrimaryGroupOverrideEditComponent,
    comp.VendSizeFlavorXrefEditComponent,
    comp.FullServicePackageConfigEditComponent,
    comp.SalesOfficeEditComponent,
    comp.ContactValidationEditComponent,

    comp.InterstitialComponent,
    comp.LoginComponent,
    comp.LogoutComponent,
    comp.ChangePasswordComponent,
    comp.ResetPasswordComponent,
    comp.ApplicationInfoComponent,

    comp.DashboardComponent,
    comp.AssignedRequestsComponent,
    comp.FullServicePricingRequestsComponent,

    comp.AttachmentsComponent,
    comp.UserInfoComponent,
    comp.GeneralDetailsComponent,
    comp.PricingComponent,
    comp.SalesAndDeliveryDetailsComponent,
    comp.BillingAddressComponent,
    comp.NotesComponent,
    comp.CoolerDetailsComponent,
    comp.FountainDetailsComponent,
    comp.VendorDetailsComponent,
    comp.PaperworkOnlyMoveDetailsComponent,
    comp.StatementDetailsComponent,
    comp.AccountingDetailsComponent,
    comp.BillingDiscrepancyDetailsComponent,
    comp.SupportRequiredDetailsComponent,
    comp.MICRDetailsComponent,
    comp.PayerLinkageDetailsComponent,
    comp.SuppressStatusComponent,
    comp.EquipmentDetailsComponent,
    comp.EquipmentLocationsComponent,
    comp.RemovalDetailsComponent,
    comp.RequestInvoiceNumbersComponent,
    comp.CompletionDetailsComponent,
    comp.DriverDetailsComponent,
    comp.CustomerRequirementsComponent,
    comp.ContactDetailsComponent,
    comp.FullServicePricingDetailsComponent,
    comp.AddressComponent,


    comp.FountainLineItemGridComponent,
    comp.VendorLineItemGridComponent,
    comp.ContactGridComponent,
    comp.CoolerLineItemGridComponent,
    comp.CustomerGridComponent,
    comp.FSVCustomerGridComponent,
    comp.VendPackageLineItemGridComponent,
    comp.EquipmentLineItemGridComponent,
    comp.PaperworkOnlyMoveLineItemGridComponent,
    comp.FullServicePricingLineItemGridComponent,
    comp.FullServiceCustomerGridComponent,
    comp.RequestActionGridComponent,
    comp.RequestCustomerGridComponent,

    comp.FountainLineItemEditComponent,
    comp.VendorLineItemEditComponent,
    comp.CoolerLineItemEditComponent,
    comp.VendPackageLineItemEditComponent,
    comp.EquipmentLineItemEditComponent,
    comp.FullServicePricingCustomerPackageEditComponent,
    comp.ContactEditComponent,

    comp.RequestsGridComponent,
    comp.RequestHistoryComponent,
    comp.RequestValidationMessagesComponent,
    comp.CustomerValidationComponent,
    comp.SelectPayerComponent,
    comp.EmployeesGridComponent,
    comp.EmployeeEditComponent,
    comp.EmployeeFeaturesComponent,
    comp.SalesOfficeApproverGridComponent,
    comp.SalesOfficeApproverEditComponent,
    comp.ChangePhoneNumberDialogComponent,
    comp.EmployeeActivationRequestsGridComponent,

    comp.MassUpdatesComponent,
    comp.CreateAccountsReceivableUpdateRequest,
    comp.CreateInvoiceStatementCopiesRequestComponent,
    comp.CreateCollectionsSetupRequestComponent,
    comp.CreateBillingDiscrepancyRequestComponent,
    comp.CreateSoldToCustomerRequestComponent,
    comp.CreateSuppressCustomerRequestComponent,
    comp.CreateUnsuppressCustomerRequestComponent,
    comp.CreateMiscellaneousRequestComponent,
    comp.CreateUpdatePricingRequestComponent,
    comp.CreateFullServiceCustomerRequestComponent,
    comp.CreateMICRChangesRequestComponent,
    comp.CreatePartnerFunctionsRequestComponent,
    comp.CreatePayerRequestComponent,
    comp.CreatePayerLinkagesRequestComponent,
    comp.CreateEquipmentOnlyRequestComponent,
    comp.CreateDriverRequestComponent,
    comp.CreateMaintainCustomerRequestComponent,
    comp.CreateEquipmentInstallRequestComponent,
    comp.CreateEquipmentRemoveRequestComponent,
    comp.CreateEquipmentSwapRequestComponent,
    comp.CreateEquipmentMoveRequestComponent,
    comp.CreateEquipmentSurveyRequestComponent,
    comp.CreateEquipmentMaintenanceRequestComponent,
    comp.CreatePaperworkOnlyMoveRequestComponent,

    comp.CreateVisitPlanUpdateRequestComponent,
    comp.CreateZRPartnerUpdateRequestComponent,

    comp.CreateFullServicePricingRequestComponent,

    comp.ContainerComponent,
    comp.UploadCompletionInfoComponent,

    comp.EquipmentTemplateRuleEditComponent,
    comp.EquipmentTemplateRuleGridComponent,
    comp.ExportFieldGridComponent,
    comp.FileFieldGridComponent,
    comp.ExportFileGridComponent,
    comp.RequestTypeFileComponent,
    comp.FieldTypeDropdownComponent,
    comp.ExportFieldEditComponent,
    comp.ExportFileGridComponent,
    comp.ExportFieldDropdownComponent,
    comp.ExportFileDropdownComponent,
    comp.FileFieldEditComponent,
    comp.RequestExportPropertyValueGridComponent,
    comp.RequestExportFileDataGridComponent,
    comp.MapComponent,

    UCDirective],
  bootstrap: [AppComponent],
  providers: [
    ConfirmationService,
    serv.AuthenticationService,
    serv.DomainDataService,
    serv.ExportService,
    serv.ConfigService,
    serv.RequestService,
    serv.CustomerService,
    serv.EquipmentService,
    serv.EmployeeService,
    serv.MassUpdatesService,
    serv.AdminService,
    AuthenticationGuard,
    serv.AddressService,
    {
      provide: APP_INITIALIZER,
      useFactory: configServiceFactory,
      deps: [serv.ConfigService],
      multi: true
    },
    MsalService,
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: MsalInterceptor,
    //   multi: true,
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MyMsalInterceptor,
      multi: true,
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    
  ]
})
export class AppModule {
  static injector: Injector;
  constructor(injector: Injector) {
    AppModule.injector = injector;
  }
}


